import React from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Menu,
  MenuItem,
} from "@mui/material";

import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";
import SettingsIcon from "@mui/icons-material/Settings";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import PrintIcon from "@mui/icons-material/Print";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CastConnectedIcon from "@mui/icons-material/CastConnected";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { renderToString } from "react-dom/server";

import { connectDB } from "../../../slices/database";
import { runQuery } from "../../../slices/query";
import NewConnection from "../Dialogs/NewConnection";
// import ExportDialog from "../../Dialogs/ExportDialog";
import { useCustomSnackbar } from "../../../CustomSnackbarProvider";
import { notifyContents } from "../../common/Notification";

const CommonToolsItem = (props) => {
  const dispatch = useDispatch();

  const snackbarWithStyle = useCustomSnackbar();

  const [newConnectionOpen, setNewConnectionOpen] = React.useState(false);
  const [displayData, setDisplayData] = React.useState("");
  // const [exportDialog, setExportDialog] = React.useState(false);

  const queryData = useSelector((state) => state.query);
  const joinCommand = useSelector((state) => state.query.joinCommand);
  const isCrossTab = useSelector((state) => state.utility.isCrossTab);
  const crosstabSelectors = useSelector(
    (state) => state.query.crosstabSelectorFields
  );
  const crosstabColumns = useSelector(
    (state) => state.query.crosstabColumnFields
  );
  const crosstabValues = useSelector(
    (state) => state.query.crosstabValueFields
  );
  const operatorType = useSelector((state) => state.query.operatorType);
  const edited = useSelector((state) => state.utility.edited);
  const codeSQL = useSelector((state) => state.utility.codeSQL);
  const parameters = useSelector((state) => state.utility.parameters);
  const sheetContent = useSelector((state) => state.query.sheetContent);

  const handleNewConnectionConnect = (dbInfos) => {
    dispatch(connectDB(dbInfos))
      .unwrap()
      .then((data) => {
        if (data.success) {
          snackbarWithStyle(notifyContents.newConnectSuccess, "success");
        } else {
          snackbarWithStyle(notifyContents.newConnectFail, "error");
        }
      });
    setNewConnectionOpen(false);
  };

  const handleNewConnectionClose = () => {
    setNewConnectionOpen(false);
  };

  // const handleExportDialogOK = () => {
  //   setExportDialog(false);
  // };

  // const handleExportDialogClose = () => {
  //   setExportDialog(false);
  // };

  const GetQueryBasedOnParam = () => {
    const selectFields = queryData.selectFields;
    let fromTable = "",
      joinFields = [],
      sortFields = [],
      filterFields = [],
      joinArray;

    let tableNameArray = [];
    selectFields.map((item) => {
      const {
        data: { table },
      } = item;
      tableNameArray.push(table);
    });
    const uniqueArray1 = [
      ...new Set(tableNameArray.filter((item) => item !== "None")),
    ];
    let modifiedTable = uniqueArray1.join(",");
    modifiedTable = modifiedTable.replace("None", "");
    modifiedTable = modifiedTable.replace(/^,|,$/g, "");
    fromTable = `FROM ${modifiedTable}`;

    queryData.relationFields.forEach((item, index) => {
      if (item.LTable.length > 0) {
        if (index === 0) fromTable = `FROM ${item.LTable[0]}`;
        joinFields.push({
          joinTable: item.RTable[0],
          LFields: item.LFields,
          RFields: item.RFields,
          Operators: item.Operator,
          joinType: item.joinType,
        });
      }
    });
    queryData.sortFields.forEach((item, index) => {
      if (index !== queryData.sortFields.length - 1) {
        const {
          data: { field, table, sortType },
        } = item;
        sortFields.push({
          field,
          table,
          sortType,
        });
      }
    });

    const typeAry1 = ["=", "!=", ">", ">=", "<", "<="];
    const typeAry2 = ["=", "!=", "Like", "Not Like"];

    queryData.filterFields.forEach((item, index) => {
      if (index !== queryData.filterFields.length - 1) {
        const { filterVariant, filterValue, operator, type } = item;
        const {
          data: { table, field },
        } = filterVariant[0];
        let typeOperator = typeAry1[operator];
        if (type === "Text") typeOperator = typeAry2[operator];
        if (filterValue.isParam) {
          filterFields.push({
            table,
            field,
            typeOperator,
            value: "@" + filterValue.parameter,
            type,
          });
        } else {
          filterFields.push({
            table,
            field,
            typeOperator,
            value: filterValue.default,
            type,
          });
        }
      }
    });

    console.log(joinCommand);
    joinArray = joinCommand.match(/\bAND\b|\bOR\b/g);
    joinArray = joinCommand.match(/\bAND\b|\bOR\b/g);
    console.log(joinArray);
    let selectQuery = "SELECT ";

    selectFields.map((item, index) => {
      const {
        data: { table, field, header_name, aggreType, command, dropbox },
      } = item;
      let prev_name = `${table}.${field}`;
      if (command == null && command == undefined) {
        if (aggreType !== "none") prev_name = `${aggreType}( ${prev_name} )`;
        if (header_name !== field)
          selectQuery += `${prev_name} as "${header_name}" `;
        if (header_name === field) selectQuery += `${prev_name}`;
        if (index !== selectFields.length - 1) selectQuery += ", \n";
      } else {
        if (command != null) {
          let updatedString = command.replace(/{\d+}/g, (match) => {
            const index = parseInt(match.match(/\d+/)[0]);
            return (
              dropbox[index - 1].filterVariant[0].data.table +
              "." +
              dropbox[index - 1].filterVariant[0].data.field
            ); // Replace {{1}} with data.body
          });
          let regex = /DAY\((.*?)\)/g;
          let matchResult;

          while ((matchResult = regex.exec(updatedString)) !== null) {
            const extractedValue = matchResult[1];
            updatedString = updatedString.replace(
              matchResult[0],
              `EXTRACT(DAY FROM ${extractedValue})`
            );
          }

          matchResult = updatedString.match(/DATE_ADD\((.*)\)/);
          if (matchResult && matchResult[1]) {
            let extractedElements = matchResult[1].split(",");
            if (
              extractedElements[0] === "'second'" ||
              extractedElements[0] === "'minute'" ||
              extractedElements[0] === "'hour'" ||
              extractedElements[0] === "'day'" ||
              extractedElements[0] === "'week'" ||
              extractedElements[0] === "'month'" ||
              extractedElements[0] === "'quarter'" ||
              extractedElements[0] === "'year'" ||
              extractedElements[0] === "'millisecond'"
            ) {
              const isDate = !isNaN(Date.parse(extractedElements[2]));
              if (isDate && extractedElements[0] !== "'millisecond'")
                extractedElements[2] = "DATE " + extractedElements[2];
              if (isDate && extractedElements[0] === "'millisecond'")
                extractedElements[2] = "TIMESTAMP " + extractedElements[2];
              if (
                extractedElements[0] !== "'year'" &&
                extractedElements[0] !== "'month'" &&
                extractedElements[0] !== "'quarter'" &&
                extractedElements[0] !== "'week'"
              )
                extractedElements[0] = `${extractedElements[0].replace(
                  /'/g,
                  ""
                )}s`;
              else
                extractedElements[0] = `${extractedElements[0].replace(
                  /'/g,
                  ""
                )}`;
              updatedString = updatedString.replace(
                /DATE_ADD\((.*)\)/,
                `${extractedElements[2]} + INTERVAL '${extractedElements[1]} ${extractedElements[0]}'`
              );
            }
          }
          regex = /DATE_DIFF\((.*?)\)/g;
          while ((matchResult = regex.exec(updatedString)) !== null) {
            const extractedElements = matchResult[1].split(",");
            updatedString = updatedString.replace(
              matchResult[0],
              `DATE_PART(${extractedElements[0]}, AGE(${extractedElements[1]},${extractedElements[2]}))`
            );
          }

          const formatStringMap = {
            "%a": "Dy",
            "%b": "Mon",
            "%c": "MM",
            "%d": "DD",
            "%e": "FMDD",
            "%f": "MS",
            "%H": "HH24",
            "%h": "HH12",
            "%I": "HH12",
            "%i": "MI",
            "%j": "DDD",
            "%k": "HH24",
            "%l": "HH12",
            "%M": "Month",
            "%m": "MM",
            "%p": "AM",
            "%r": "HH:MI:SSam",
            "%s": "SS",
            "%S": "SS",
            "%T": "HH24:MI:SS",
            "%v": "WW",
            "%W": "Day",
            "%x": "IYYY",
            "%Y": "YYYY",
            "%y": "YY",
            "%%": "%%",
          };
          regex = /DATE_FORMAT\((.*?)\)/g;

          while ((matchResult = regex.exec(updatedString)) !== null) {
            const extractedElements = matchResult[1].split(",");
            extractedElements[1] = extractedElements[1].replace(/'/g, "");
            const newFormat = formatStringMap[extractedElements[1]];
            updatedString = updatedString.replace(
              matchResult[0],
              `TO_CHAR(${extractedElements[0]}::DATE, '${newFormat}')`
            );
          }

          regex = /EOMONTH\((.*?)\)/g;

          while ((matchResult = regex.exec(updatedString)) !== null) {
            const extractedElements = matchResult[1].split(",");
            extractedElements[1] = extractedElements[1].replace(/'/g, "");
            updatedString = updatedString.replace(
              matchResult[0],
              `DATE_TRUNC('MONTH', ${extractedElements[0]}::date) + INTERVAL '1 MONTH - 1 DAY' * ${extractedElements[1]}`
            );
          }

          regex = /MONTH\((.*?)\)/g;

          while ((matchResult = regex.exec(updatedString)) !== null) {
            const extractedValue = matchResult[1];
            updatedString = updatedString.replace(
              matchResult[0],
              `EXTRACT(MONTH FROM ${extractedValue})`
            );
          }

          regex = /YEAR\((.*?)\)/g;

          while ((matchResult = regex.exec(updatedString)) !== null) {
            const extractedValue = matchResult[1];
            updatedString = updatedString.replace(
              matchResult[0],
              `EXTRACT(YEAR FROM ${extractedValue})`
            );
          }

          regex = /QUARTER\((.*?)\)/g;

          while ((matchResult = regex.exec(updatedString)) !== null) {
            const extractedValue = matchResult[1];
            updatedString = updatedString.replace(
              matchResult[0],
              `EXTRACT(QUARTER FROM ${extractedValue})`
            );
          }

          if (updatedString === "") updatedString = null;
          updatedString += " as ";
          updatedString += `"${header_name}"`;
          if (index !== selectFields.length - 1)
            selectQuery += updatedString + ", \n";
          else selectQuery += updatedString;
        }
      }
    });

    let groupByQuery = "GROUP BY";
    let isGroupBy = 0;

    selectFields.map((item, index) => {
      const {
        data: { aggreType },
      } = item;
      if (aggreType !== "none") isGroupBy = 1;
    });

    if (isGroupBy) {
      let cnt = 0;
      selectFields.map((item, index) => {
        const {
          data: { table, field, aggreType },
        } = item;
        if (aggreType == "none" && field !== "None") {
          let string = " " + table + "." + field;
          groupByQuery += string;
          groupByQuery += ",";
          cnt++;
        }
      });
      groupByQuery = groupByQuery.slice(0, -1);
      if (cnt === 0) isGroupBy = 0;
    }

    if (isCrossTab) {
      selectQuery = "SELECT ";
      crosstabSelectors.map((item, index) => {
        const {
          data: { table, field },
        } = item;
        selectQuery += `${table}.${field}`;
        selectQuery += ", \n";
        if (crosstabValues[0].id !== "none") {
          let string = " " + table + "." + field;
          if (index < crosstabSelectors.length) groupByQuery += string;
          if (index < crosstabSelectors.length - 1) groupByQuery += ",";
          if (
            index == crosstabSelectors.length - 1 &&
            crosstabValues[0].id !== "none"
          )
            groupByQuery += ",";
        }
      });

      if (crosstabColumns[0].id !== "none") {
        const {
          data: { table, field },
        } = crosstabColumns[0];
        selectQuery += `${table}.${field}`;
        selectQuery += ", \n";
        if (crosstabValues[0].id !== "none") {
          let string = " " + table + "." + field;
          groupByQuery += string;
        }
      }

      if (crosstabValues[0].id !== "none") {
        const {
          data: { table, field },
        } = crosstabValues[0];
        selectQuery += `${operatorType.changed}(${table}.${field})`;
      }
    }

    let joinQuery = "";
    const joinTypeArray = [
      "LEFT JOIN",
      "RIGHT JOIN",
      "INNER JOIN",
      "FULL JOIN",
    ];
    const OperatorTypeArray = ["=", "!=", ">", ">=", "<", "<="];

    joinFields.map((item) => {
      const { joinTable, LFields, RFields, Operators, joinType } = item;
      let joinString = `${joinTypeArray[joinType]} ${joinTable} ON`;
      for (let i = 0; i < LFields.length; i++) {
        joinString += ` ${LFields[i]}${OperatorTypeArray[Operators[i]]}${
          RFields[i]
        }`;
        if (i !== LFields.length - 1) {
          joinString += " AND";
        }
      }
      joinQuery += `${joinString}\n`;
    });

    let sortQuery = "ORDER BY";

    sortFields.forEach((item, index) => {
      sortQuery += ` ${item.table}.${item.field} ${item.sortType}`;
      if (index !== sortFields.length - 1) sortQuery += ",";
    });

    let whereQuery = "WHERE ";

    console.log(joinArray);
    filterFields.map((item, index) => {
      if (index > 0) {
        whereQuery += `\n      ${joinArray[index - 1]} `;
      }

      let valueString = item.value;
      if (item.type === "Text") valueString = `'${item.value}'`;
      let condition = "";
      if (item.typeOperator === "Like" || item.typeOperator === "Not Like") {
        condition =
          item.table +
          "." +
          item.field +
          " " +
          item.typeOperator.toUpperCase() +
          " " +
          `'%${item.value}%'`;
      } else
        condition =
          item.table + "." + item.field + item.typeOperator + valueString;
      whereQuery += condition;
    });

    let query = "";
    let cSelectQuery = "";

    if (selectFields.length > 0) {
      query += selectQuery + "\n";
    }

    if (fromTable) query += fromTable + "\n";
    if (joinFields.length > 0) query += joinQuery;
    if (filterFields.length > 0) query += whereQuery + "\n";
    if (isGroupBy) query += groupByQuery + "\n";
    if (!isCrossTab && sortFields.length > 0) query += sortQuery + "\n";
    if (isCrossTab && crosstabValues[0].id !== "none")
      query += groupByQuery + "\n";

    if (isCrossTab) {
      if (crosstabColumns[0].id !== "none") {
        const {
          data: { table, field },
        } = crosstabColumns[0];
        cSelectQuery = `SELECT DISTINCT ${field} FROM ${table} ORDER BY 1`;
      }

      const queryInfo = {
        query: cSelectQuery,
      };

      dispatch(runQuery(queryInfo))
        .then((data) => {
          let newParam = "";
          crosstabSelectors.map((item, index) => {
            const {
              data: { table, field },
            } = item;
            let type = "text";
            newParam += `${field} ${type},`;
          });

          let selectQuery = newParam;
          data.payload.rows.forEach((item, index) => {
            const key = Object.keys(item)[0];
            const value = item[key].replaceAll(" ", "_");
            let type = "text";
            if (typeof value == "string") type = "text";
            selectQuery += `${value} ${type}`;
            if (index !== data.payload.rows.length - 1) selectQuery += ",";
          });
          let crosstabQuery = `SELECT * FROM crosstab('${query}', '${cSelectQuery}') AS virtualTable (${selectQuery});`;
          query = crosstabQuery;
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      // setDefaultList(query);
    }
    if (edited || isCrossTab) query = codeSQL;

    queryData.filterFields.forEach((item, index) => {
      if (index !== queryData.filterFields.length - 1) {
        const { filterVariant, filterValue, operator, type } = item;
        const {
          data: { table, field },
        } = filterVariant[0];
        let typeOperator = typeAry1[operator];
        if (type === "Text") typeOperator = typeAry2[operator];
        let filterText = "";
        if (filterValue.isParam) {
          const parameterName = filterValue.parameter;
          parameters.forEach((item) => {
            if (item.name === parameterName) {
              filterText = item.value;

              query = query.replace("@" + filterValue.parameter, filterText);
            }
          });
        } else filterText = filterValue.default;
        filterFields.push({
          table,
          field,
          typeOperator,
          value: filterText,
          type,
        });
      }
    });

    console.log(query);

    return query;
  };

  let iconToRender;
  let itemText = (
    <ListItemText
      primary={props.text}
      primaryTypographyProps={{ fontSize: "0.7rem" }}
      sx={{ justifyContent: "center", whiteSpace: "nowrap" }}
    />
  );

  let handleClick = () => {
    console.log("CommonTools", props.text, "clicked!");
  };

  switch (props.text) {
    case "Undo":
      iconToRender = <UndoIcon sx={{ color: "#F9B13C" }} />;
      break;
    case "Redo":
      iconToRender = <RedoIcon sx={{ color: "#99C7EF" }} />;
      break;
    case "Properties":
      iconToRender = <SettingsIcon />;
      itemText = (
        <PopupState variant="popover" popupId="demo-popup-menu">
          {(popupState) => (
            <React.Fragment>
              <Button
                {...bindTrigger(popupState)}
                sx={{
                  fontSize: "0.7rem",
                  color: "inherit",
                  padding: 0,
                  fontWeight: 400,
                  textTransform: "none",
                }}
                endIcon={<ArrowDropDownIcon />}
              >
                Properties
              </Button>
              <Menu {...bindMenu(popupState)}>
                <MenuItem onClick={popupState.close}>Profile</MenuItem>
                <MenuItem onClick={popupState.close}>My account</MenuItem>
                <MenuItem onClick={popupState.close}>Logout</MenuItem>
              </Menu>
            </React.Fragment>
          )}
        </PopupState>
      );
      break;
    case "SaveAs":
      iconToRender = <SaveAsIcon />;
      break;
    case "Print":
      iconToRender = <PrintIcon />;
      break;
    case "Connect":
      iconToRender = <CastConnectedIcon />;
      handleClick = () => {
        setNewConnectionOpen(true);
      };
      break;
    case "Run Query":
      iconToRender = <PlayCircleIcon />;
      handleClick = () => {
        const query = GetQueryBasedOnParam();
        const queryInfo = {
          query: query,
        };
        dispatch(runQuery(queryInfo)).then((data) => {
          if (data.hasOwnProperty("error")) {
            snackbarWithStyle(notifyContents.runQueryFail, "error");
          } else {
            snackbarWithStyle(notifyContents.runQuerySuccess, "success");
          }
          console.log(data.payload)
          const { fields, rows } = data.payload;

        });
      };
      break;
    default:
      iconToRender = <HomeOutlinedIcon />;
  }
  return (
    <ListItem key={props.text} disablePadding>
      <ListItemButton
        sx={{
          minHeight: 60,
          justifyContent: "center",
          px: 2.5,
          display: "flex",
          flexDirection: "column",
        }}
        onClick={handleClick}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
          }}
        >
          {iconToRender}
        </ListItemIcon>
        {itemText}
      </ListItemButton>
      {/* <ExportDialog
        open={exportDialog}
        data={displayData}
        handleExportDialogClose={handleExportDialogClose}
        handleExportDialogOK={handleExportDialogOK}
      /> */}
      <NewConnection
        open={newConnectionOpen}
        handleConnect={handleNewConnectionConnect}
        handleClose={handleNewConnectionClose}
      />
    </ListItem>
  );
};

export default CommonToolsItem;
